import React, { useState , useEffect } from 'react'
import './Form.css';
import { Container, Divider, Button, TextField, ThemeProvider, Paper, Checkbox, FormControlLabel, Grid, Typography, LinearProgress } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import FormHeader from '../FormHeader';
import theme from '../theme';
import submitpost from '../../utils/submitpost';
import ThankYou from '../ThankYou';

type Inputs = {
    url: string,
    medium_handle: string,
    email: string,
    notes?: string
  };

export default function Form() {
    const [isDisabled, setIsDisabled] = useState<boolean>(false);
    const { register, handleSubmit } = useForm<Inputs>();
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
    const [postFeedback, setPostFeedback] = useState({code: '', message: ''});

    const onSubmit = (data : Inputs) => { 
        setIsDisabled(true);
        submitpost(data).then(ans => {
            console.log("Forn was submitted: ", ans);
            setPostFeedback(ans);
        });
        
    };

    useEffect(() => {
        if (postFeedback.code.length > 0) {
            setIsSubmitted(true)}
            console.log("postFeedback", postFeedback)
        },[postFeedback]);
 
    return (
        <div>
            <ThemeProvider theme={theme}>
                <Container maxWidth='sm' style={{padding: 'unset'}}>
                    <Paper elevation={4} style={{padding: '24px', marginTop: '50px'}} >
                        {!isSubmitted && 
                        <form onSubmit={handleSubmit(onSubmit)}>
                        <FormHeader />
                            <TextField disabled={isDisabled} type="url" required autoComplete='off' name="url" inputRef={register} id="standard-basic" label="A link to your story" fullWidth className="text-field" style={{marginBottom: '25px'}}/>
                            <TextField disabled={isDisabled} required autoComplete='off' name="medium_handle" inputRef={register}  id="standard-basic" label="Your Medium handle (username)" fullWidth className="text-field" style={{marginBottom: '25px'}}/>
                            <TextField disabled={isDisabled} type="email" autoComplete='off' name="email" inputRef={register} required id="standard-basic" label="Your email" fullWidth className="text-field" style={{marginBottom: '25px'}}/>
                            <TextField disabled={isDisabled} label="Notes" autoComplete='off' multiline rowsMax={5} name="notes" inputRef={register} fullWidth className="text-field" style={{marginBottom: '35px'}} />
                            <Typography variant="h6" component="h2" style={{color: '#756d6a'}}>Is your story suitable for our publication?</Typography>
                            <FormControlLabel control={<Checkbox disabled={isDisabled} required color="primary"/>} label="This story is about front-end development/ NodeJS" style={{color: '#756d6a'}}/>
                            <FormControlLabel control={<Checkbox disabled={isDisabled} required color="primary"/>} label='This story was not published elsewhere' style={{color: '#756d6a'}} />
                            <Divider light style={{marginBottom: '25px', marginTop: '25px'}} />
                            <Grid container direction="row" justify="flex-end"> 
                                {!isDisabled && <Button variant="contained" color="primary" type="submit">Submit</Button>}
                            </Grid>
                            {isDisabled && <LinearProgress color="primary" />}
                        </form>
                        }
                        {isSubmitted && <ThankYou postFeedback={postFeedback} />}
                    </Paper>
                </Container>
            </ThemeProvider>
        </div>
    )
}
